import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@mui/material/ListItem';

const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
}));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    fullWidth: {
        width: "100%"
    },
}));


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MfaSettings = (props) => {
    const classes = useStyles();

    const [isSavingUser, setIsSavingUser] = useState(false)
    const [showMessageDialog, setShowMessageDialog] = useState(false)
    const [isSavingSuccess, setIsSavingSuccess] = useState(false)
    const [messageDialogMessage, setMessageDialogMessage] = useState("")
    const [emailVerificationDialogMessage, setEmailVerificationDialogMessage] = useState(false)
    const [isSavingEmailVerificationSuccess, setIsSavingEmailVerificationSuccess] = useState(false)
    const [isEmailVerified, setIsEmailVerified] = useState(0);
    const [mfaData, setMfaData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [user, setUser] = useState({
        id: "",
        username: "",
        email_address: ""
    })



    const inputOnChangeListener = (event) => {
        const modifiedUser = { ...user }

        modifiedUser[event.target.name] = event.target.value
        setUser(modifiedUser)
    }

    const [emailVerificationCode, setEmailVerificationCode] = useState({
        email_verification_code: ""
    })

    const inputOnChangeEmailVerificationListener = (event) => {
        const modifiedEmailVerificationCode = { ...emailVerificationCode }
        modifiedEmailVerificationCode[event.target.name] = event.target.value
        setEmailVerificationCode(modifiedEmailVerificationCode)
    }
    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
        formData.append(key, object[key]);

        return formData;
    }, new FormData())

    useEffect(() => {
        getUserDetails();
        getUserMfaDetails();
    }, [props.openDialogSettings])

    const getUserDetails = async () => {
        const options = {
            method: 'POST',
            url: '/User/getUserInformationDetails.json'
        }

        const response = await axios(options)
        const is_success = response.data.response.is_success;
        const user_details = response.data.response.user_info;
        if (is_success) {

            const edit_user = { ...user }
            edit_user.username = user_details.username;
            edit_user.id = user_details.id;
            setIsEmailVerified(user_details.email_verified)
        }
    }

    const getUserMfaDetails = async () => {
        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/get-mfa-email-settings.json'
        }

        const response = await axios(options)
        const is_success = response.data.response.is_success;
        const mfa_details = response.data.response.data;
        if (is_success) {
            setMfaData(mfa_details)
            setUser({
                id: "",
                username: "",
                email_address: ""
            })
        }
    }

    function addMfaEmail() {
        setIsLoading(true);
        setIsSavingUser(true)
        const newUserDetails = { ...user }

        setIsSavingUser(true)
        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/add-mfa-email-settings.json',
            data: objectToFormData(newUserDetails)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message

                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)
                    setIsLoading(false)
                    return;
                }

                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage("Multi-Factor Authentication (MFA) successfully save.")
                setShowMessageDialog(true)
                setUser({
                    id: "",
                    username: "",
                    email_address: ""
                })
                setIsLoading(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
                setIsLoading(false)
            })
    }

    function verifyEmail(params) {
        setIsSavingUser(true)
        setIsLoading(true)
        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/send-mfa-email-verification.json',
            data: objectToFormData(params)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)
                    setIsLoading(false)

                    return;
                }
                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)
                setIsLoading(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
                setIsLoading(false)


            })

    }

    function updateMfaStatus(params) {
        setIsLoading(true)
        setIsSavingUser(true)
        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/update-mfa-email-settings.json',
            data: objectToFormData(params)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)
                    setIsLoading(false)


                    return;
                }
                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)
                setIsLoading(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
                setIsLoading(false)


            })

    }

    function deleteMfaSettings(params) {
        setIsLoading(true)
        setIsSavingUser(true)
        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/delete-mfa-email-settings.json',
            data: objectToFormData(params)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)
                    setIsLoading(false)

                    return;
                }
                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)
                setIsLoading(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
                setIsLoading(false)


            })

    }

    function editMfaEmail(params) {
        setIsLoading(true)
        setIsSavingUser(true)
        const newUserDetails = { ...user }
        newUserDetails.id = params.id
        newUserDetails.username = params.system_username

        const options = {
            method: 'POST',
            url: '/TransactiLiteMultiFactorAuthentications/edit-mfa-email-settings.json',
            data: objectToFormData(newUserDetails)
        }
        axios(options)
            .then(res => {
                const isSuccess = res.data.response.is_success
                const message = res.data.response.message
                if (!isSuccess) {

                    setIsSavingSuccess(false)
                    setIsSavingUser(false)
                    setMessageDialogMessage(res.data.response.message)
                    setShowMessageDialog(true)
                    setEmailVerificationDialogMessage(true)
                    setIsSavingEmailVerificationSuccess(true)
                    setIsLoading(false)


                    return;
                }
                setIsSavingEmailVerificationSuccess(false)
                setIsSavingSuccess(true)
                setIsSavingUser(false)
                setMessageDialogMessage(message)
                setShowMessageDialog(true)
                setIsLoading(false)

            }).catch(error => {

                setIsSavingSuccess(false)
                setIsSavingUser(false)
                setMessageDialogMessage(error.message)
                setShowMessageDialog(true)
                setIsLoading(false)


            })

    }

    function progressDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={isSavingUser}
                onClose={() => { }}
            >

                <DialogContent>
                    <DialogContentText>
                        Processing... Please wait...
                    </DialogContentText>
                    <LinearProgress color="secondary" />
                </DialogContent>
            </Dialog>
        )
    }


    function messageDialog() {
        return (
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                open={showMessageDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {messageDialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowMessageDialog(false)
                        getUserMfaDetails()
                        if (isSavingSuccess) {
                            props.setOpenDialogSettings(false)
                            setEmailVerificationCode({ email_verification_code: "" });
                            window.location.reload();
                        }

                        if (isSavingEmailVerificationSuccess) {
                            setEmailVerificationDialogMessage(true)
                        }

                    }}
                        color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <div>

            <Dialog fullScreen open={props.openDialogSettings} onClose={() => {


            }} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => {
                                props.setOpenDialogSettings(false)
                            }


                            }
                            aria-label="close"
                            size="large">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="subtitle1" className={classes.title}>
                            {"Multi-Factor Authentication (MFA) Settings"}
                        </Typography>
                    </Toolbar>
                </AppBar>
               
                <div className={classes.appBarSpacer}></div>
                {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
                <div style={{ padding: '.5rem' }}>

                    <Grid container spacing={1}>

                        <Grid item xs={12}>
                            Email Address*
                        </Grid>
                        <Grid item xs={12}>
                            <StyledEngineProvider injectFirst>
                                <ThemeProvider theme={materialTheme}>
                                    <form noValidate>
                                        <TextField
                                            className={classes.fullWidth}
                                            value={user.email_address}
                                            name="email_address"
                                            id="email_address"
                                            rows={4}
                                            variant="outlined"
                                            onChange={inputOnChangeListener}
                                        />
                                    </form>
                                </ThemeProvider>
                            </StyledEngineProvider>
                        </Grid>

                        {Object.keys(mfaData).length > 0 ? (
                            <>
                                <Grid item container >
                                    <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={() => { editMfaEmail(mfaData); }}>
                                        Edit Email
                                    </Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <StyledEngineProvider injectFirst>
                                        <ThemeProvider theme={materialTheme}>
                                            <List>
                                                <ListItem divider>
                                                    <div>
                                                        <Typography variant="body1">
                                                            <b>Email Address: </b> {mfaData.email}
                                                            <br />
                                                            <b>Verified: </b>
                                                            <span style={{ color: mfaData.verified == 1 ? "green" : "red" }}>
                                                                {mfaData.verified == 1 ? "YES" : "NO"}
                                                            </span>
                                                            <br />
                                                            <b>MFA Status: </b>
                                                            <span style={{ color: mfaData.settings == 1 ? "green" : "red" }}>
                                                                {mfaData.settings == 1 ? "ON" : "OFF"}
                                                            </span>
                                                            <br />
                                                            <b>Created: </b>{mfaData.created}
                                                            <br />
                                                            <b>Modified: </b>{mfaData.modified}
                                                        </Typography>
                                                    </div>
                                                </ListItem>
                                            </List>
                                        </ThemeProvider>
                                    </StyledEngineProvider>
                                </Grid>
                                {mfaData.verified !== 1 && (
                                    <Grid item container >
                                        <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={() => { verifyEmail(mfaData); }}>
                                            Verify Email
                                        </Button>
                                    </Grid>
                                )}

                                {mfaData.verified !== 0 && (
                                    <Grid item container >
                                        <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={() => { updateMfaStatus(mfaData); }}>
                                            MFA Status {mfaData.settings == 1 ? "ON" : "OFF"}
                                        </Button>
                                    </Grid>
                                )}


                                <Grid item container >
                                    <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={() => { deleteMfaSettings(mfaData); }}>
                                        Delete
                                    </Button>
                                </Grid>
                            </>
                        ) : (
                            <Grid item container >
                                <Button variant="contained" color="primary" style={{ width: "100%" }} onClick={addMfaEmail}>
                                    Add Email
                                </Button>
                            </Grid>
                        )}


                    </Grid>
                </div>
            </Dialog>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                    {progressDialog()}
                    {messageDialog()}
                </ThemeProvider>
            </StyledEngineProvider>
        </div>
    );
}

export default MfaSettings